export const spaceName = 'odCoupons';

export interface CouponsSettings {
  showDrawer: {
    show: boolean;
    key?: 'create';
  };
  selectedIds: Number[];
  tabActiveKey: 'published' | 'draft';
  currentPageInfo: {
    data: any;
    params: {
      currentPage: Number;
      pageSize: Number;
      total: Number;
    };
  };
  searchItem: string | false;
  sortItem:
    | {
        sortedBy: string;
        sortedOrder: 'ascend' | 'descend' | false;
      }
    | false;
  filter:
    | {
        type: any[];
      }
    | false;
  couponCode: any;
}

export default {
  tabActiveKey: 'published',
  showDrawer: {
    show: false,
  },
  selectedIds: [],
  currentPageInfo: {
    data: [],
    params: {
      currentPage: 1,
      pageSize: 12,
      total: 0,
    },
  },
  searchItem: false,
  sortItem: false,
  filter: false,
  couponCode: '',
} as CouponsSettings;
